import { useCallback, useMemo } from 'react';
import { useCurrency } from 'hooks/useCurrency';

window.klrq = window.klrq || [];

export const useKlear = () => {
  const currency = useCurrency();

  const orderCompleteAction = useCallback(
    (items) => {
      const data = {
        currency: currency.code,
        items: items.map((item) => {
          return {
            value: item.unit_price,
            name: item.product.name,
            quantity: item.quantity,
          };
        }),
      };

      window.klrq.push(['conversion', data]);
    },
    [currency.code]
  );

  return useMemo(
    () => ({
      orderCompleteAction,
    }),
    [orderCompleteAction]
  );
};
